export default __webpack_public_path__ + "static/media/logo-go-mybiz.52b8cfb4.png";